import React, {Component} from 'react';
import PropTypes from 'prop-types';

import Tooltip from '@homeaway/react-tooltip';
import './collaborator-display.less';

const collaboratorFilter = (collaborator) => collaborator && collaborator.profile;
class CollaboratorDisplay extends Component {
    static propTypes = {
        users: PropTypes.arrayOf(PropTypes.shape({
            profile: PropTypes.object
        }))
    }

    static defaultProps = {
        users: []
    }

    capitalizeInitial = (name) => {
        return name && name.length > 0 && name.charAt(0).toUpperCase() || '';
    }

    capitalizeName = (name) => {
        return `${this.capitalizeInitial(name)}${name.slice(1)}`;
    }

    generateInitials = (profile) => {
        return profile && `${this.capitalizeInitial(profile.firstName)}${this.capitalizeInitial(profile.lastName)}` || '';
    }

    generateRemainderInitials = (remainder) => {
        return remainder.filter(collaboratorFilter).map((collaborator) => `${this.capitalizeName(collaborator.profile && collaborator.profile.firstName || '')} ${this.capitalizeInitial(collaborator.profile && collaborator.profile.lastName || '')}.`).join(', ');
    }

    hasImage = (profile) => {
        return !!profile && profile.publicImageUrl
        && profile.publicImageUrl !== ''
        && profile.publicImageUrl.indexOf('default-profile-pic.png') === -1;
    }

    render() {
        let {users: collaborators = []} = this.props;

        let remainder = [];
        const collaboratorDisplayLimit = 7;
        const collaboratorAnimationDelay = 50;
        if (collaborators.length > collaboratorDisplayLimit) {
            remainder = collaborators.slice(collaboratorDisplayLimit, collaborators.length);
            collaborators = collaborators.slice(0, collaboratorDisplayLimit);
        }
        return (
            <div className="tripboard-details-collaborators">
                {(remainder.length > 0 &&
                    <Tooltip
                        content={this.generateRemainderInitials(remainder)}
                        wrapperStyle={{zIndex: collaborators.length}}
                    >
                        <div
                            style={{animationDelay: `${collaboratorAnimationDelay}ms`}}
                            className="tripboard-details-collaborators__collaborator"
                        >
                            <div className="tripboard-details-collaborators__collaborator-display">
                                {`+${remainder.length}`}
                            </div>
                        </div>
                    </Tooltip>
                )}
                {(collaborators.filter(collaboratorFilter).map(({profile}, index) => {
                    return (
                        <Tooltip
                            content={`${this.capitalizeName(profile && profile.firstName || '')} ${this.capitalizeName(profile && profile.lastName || '')}`}
                            wrapperStyle={{zIndex: `${(collaborators.length - 1) - index}`}}
                            key={index}
                        >
                            <div
                                style={{animationDelay: `${(index + 1) * collaboratorAnimationDelay}ms`}}
                                className="tripboard-details-collaborators__collaborator"
                            >
                                <div className="tripboard-details-collaborators__collaborator-display"
                                    style={(
                                        this.hasImage(profile) ? {backgroundImage: `url(${profile.publicImageUrl})`} : {}
                                    )}
                                >
                                    {this.hasImage(profile) ? '' : this.generateInitials(profile)}
                                </div>
                            </div>
                        </Tooltip>
                    );
                }
                ))}
            </div>
        );
    }
}

export default CollaboratorDisplay;



// WEBPACK FOOTER //
// ./src/universal/tripboard/collaborate/components/collaborator-display.js